import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';

import { AppRoutingModule } from './app-routing.module';
import { AppNavbarComponent } from './app-components/app-navbar/app-navbar.component';
import { AppSocialLinksComponent } from './app-components/app-social-links/app-social-links.component';
import { AppFooterComponent } from './app-components/app-footer/app-footer.component';
import { AppEncabezadoLogosComponent } from './app-components/app-encabezado-logos/app-encabezadoLogos.component';

import { LayoutComponent } from './app-components/layout/layout.component'

import { CompartidoModule } from './modulos/compartido/compartido.module';
import { HttpClientModule } from '@angular/common/http';
import {NgxPaginationModule} from 'ngx-pagination';

@NgModule({
  declarations: [
    AppComponent,
    AppNavbarComponent,
    AppSocialLinksComponent,
    AppFooterComponent,
    AppEncabezadoLogosComponent,
    LayoutComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CompartidoModule,
    HttpClientModule,
    NgxPaginationModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
